import React from 'react';
import CONFIG from '../../Config';

import { referralFooterURL } from '../../Config';
import InputText from  './input/InputText';
import InputMenu from './input/InputMenu';
import InputMulti from './input/InputMulti';
import InputReferral from './input/InputReferral';
import TypingSwitchMobile from '../typing-switch/TypingSwitchMobile';
import KeywordSelector from '../keywords/KeywordSelector';

class InputBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brand_name: props.brand_name,
      branding: props.branding,
      keywords: props.keywords,
      typing: props.typing,
      disabled: props.disabled,
      input_motion: props.input_motion,
      sendMessage: props.sendMessage,
      input_type: props.input_type, // text, field, menu, multi
      field: props.field,
      buttons: props.buttons,
      payloads: props.payloads,
      extra: props.extra,
      backButton: props.backButton,
    };
    this.textSubmitHandler = this.textSubmitHandler.bind(this);
    this.buttonSubmitHandler = this.buttonSubmitHandler.bind(this);
    this.backButtonElem = null;
    this.ee = props.ee;

    this.remountID = '0';
  }

  /**
   * Remount algorithm. This parameter ensures a refresh in every input
   * for each incoming message, avoiding repeated behaviors from identical
   * buttons inputs.
   */
  componentWillReceiveProps(nextProps) {
    if (this.props.disabled === true && nextProps.disabled === false)
      this.remountID = Math.random().toString();
  }

  shouldComponentUpdate(nextProps) {
    const {
      typing,
      disabled,
      input_motion,
      input_type,
      field,
      buttons,
      payloads, 
      extra
    } = this.props;

    if (
      typing === nextProps.typing &&
      // disabled === true &&
      disabled === nextProps.disabled &&
      // input_motion === false &&
      input_type === nextProps.input_type &&
      field === nextProps.field &&
      this.compareObjects(buttons, nextProps.buttons) &&
      this.compareObjects(payloads, nextProps.payloads) &&
      this.compareObjects(extra, nextProps.extra)
    ) {
      return false;
    }
//     console.log(`===========================
// ${disabled === nextProps.disabled}
// ${input_motion === false}
// ${input_type === nextProps.input_type}
// ${field === nextProps.field}
// ${this.compareObjects(buttons, nextProps.buttons)}
// ${this.compareObjects(payloads, nextProps.payloads)}
// ${this.compareObjects(extra, nextProps.extra)}
// `)
    return true;
  }

  compareObjects(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  getExtraTextareaData(data) {
    return {
      field: this.getExtraField(data),
      type: this.getExtraType(data),
      value: this.getExtraValue(data),
      fixed: this.getExtraFixed(data),
    };
  }

  getExtraField(data) {
    try {
      return data.textarea.field;
    } catch(e) {
      return false;
    }
  }

  getExtraType(data) {
    try {
      return data.textarea.type;
    } catch(e) {
      return null;
    }
  }

  getExtraValue(data) {
    try {
      return data.textarea.value;
    } catch(e) {
      return null;
    }
  }

  getExtraFixed(data) {
    try {
      return data.textarea.fixed;
    } catch(e) {
      return null;
    }
  }

  getExtraButtonsData(data) {
    return {
      dual_buttons: this.getExtraDualButtons(data),
      pile_up: this.getExtraPileUp(data),
      includes: this.getExtraIncludes(data),
      images: this.getExtraImages(data),
      icons: this.getExtraIcons(data),
      multi: this.getExtraMulti(data),
      search: this.getExtraSearch(data),
    };
  }

  getExtraDualButtons(data) {
    try {
      return data.buttons.dual_buttons; 
    }
    catch(e) {
      return false; 
    }
  }
  
  getExtraPileUp(data) {
    try { 
      return data.buttons.pile_up; 
    }
    catch(e) {
      return false; 
    }
  }

  getExtraIncludes(data) {
    try { 
      return data.buttons.includes; 
    }
    catch(e) {
      return []; 
    }
  }

  getExtraImages(data) {
    try { 
      return data.buttons.images; 
    }
    catch(e) {
      return []; 
    }
  }

  getExtraIcons(data) {
    try { 
      return data.buttons.icons; 
    }
    catch(e) {
      return []; 
    }
  }

  getExtraMulti(data) {
    try { 
      return data.buttons.multi; 
    }
    catch(e) {
      return false; 
    }
  }

  getExtraSearch(data) {
    try { 
      return data.buttons.search; 
    }
    catch(e) {
      return false; 
    }
  }

  buttonSubmitHandler(text, payload) {
    if (this.props.disabled)
      return;
    this.props.sendMessage(text, payload);
  }

  textSubmitHandler(text, images = [], image_flags = []) {
    if (this.props.disabled)
      return;
    this.props.sendMessage(text, null, images, image_flags);
  }

  backClick(text) {
    if (this.props.disabled)
      return;
    this.props.sendMessage('#back');
    this.backButtonElem.blur();
  }

  render() {
    const { disabled } = this.props;
    const {
      brand_name,
      branding,
      keywords,
      typing,
      input_motion,
      input_type,
      field,
      field_type,
      buttons = [],
      payloads = [],
      extra,
      backButton,
      lastMessage,
    } = this.props;

    let _backButton = (
      <div className="hu-input-back">
        <button 
          className="back-button hu-color_contrast hu-border-color_contrast not-selectable hu-s-10"
          onClick={this.backClick.bind(this)}
          tabIndex={(buttons) ? Object.keys(buttons).length + 1 : 5}
          ref={(elem) => {this.backButtonElem = elem;}}
        >
          <span className="left-arrow">
            <svg className="hu-fill_contrast" xmlns="http://www.w3.org/2000/svg">
              <path d="M 11.78125 2.28125 L 2.78125 11.28125 L 2.09375 12 L 2.78125 12.71875 L 11.78125 21.71875 L 13.21875 20.28125 L 5.9375 13 L 22 13 L 22 11 L 5.9375 11 L 13.21875 3.71875 Z "></path>
            </svg>
          </span>
          <span className="back-text hu-t-uppercase">{ CONFIG.text.back }</span>
        </button>
      </div>
    );
    const textareaData = this.getExtraTextareaData(extra);
    const buttonsData = this.getExtraButtonsData(extra);
    let input = null;

    switch (input_type) {
      case 'text':
        input = (
          <InputText
            key={this.remountID}
            emoji={this.props.emoji}
            field_type={field_type}
            fixed={this.props.fixed}
            textareaData={textareaData}
            textSubmitHandler={this.textSubmitHandler}
            ee={this.ee}
          />
        );
        break;
      case 'field':
        input = (
          <InputText
            key={this.remountID}
            emoji={this.props.emoji}
            field={field}
            field_type={field_type}
            textareaData={textareaData}
            textSubmitHandler={this.textSubmitHandler}
            ee={this.ee}
          />
        );
        break;
      case 'menu':
        input = (
          <InputMenu
            key={this.remountID}
            buttons={buttons}
            payloads={payloads}
            buttonsData={buttonsData}
            buttonSubmitHandler={this.buttonSubmitHandler}
            clicked={false}
          />
        );
        break;
      case 'multi':
        input = (
          <InputMulti
            key={this.remountID}
            buttons={buttons}
            payloads={payloads}
            buttonsData={buttonsData}
            buttonSubmitHandler={this.buttonSubmitHandler}
            clicked={false}
          />
        );
        break;
      case 'referral':
        let brand = '';
        try {
          brand = lastMessage.data.brand;
        } catch(e) {}
        input = InputReferral(brand);
        break;
      default:
        _backButton = null;
        input = null;
        break;
    }
    
    if (input_motion) {
      if (input_type == 'menu' && buttons.length == 0)
        return (
          <div className="hu-input-container"></div>
        );
      return (
        <div className={`hu-input-container ${input_type}`}>
          { (brand_name && branding) &&
            <div className="hu-mobile-powered-by">
              <p className="powered-by-text hu-a-center hu-color_contrast hu-s-12">
                <a className="hu-border-color_contrast" target="_blank" href={referralFooterURL}>Create your own <b>Landbot</b></a>
                {/* By <a className="hu-border-color_contrast" target="_blank" href={referralFooterURL}><b>Landbot.io</b></a> */}
              </p>
            </div>
          }
          <div className="hu-input-header">
            { backButton && _backButton }
            { keywords &&
              <KeywordSelector
                keywords={keywords}
                ee={this.ee}
              />
            }
            { typing !== undefined &&
              <TypingSwitchMobile 
                ee={this.ee}
                typing={typing}
              />
            }
            {/* (brand_name && branding) &&
              <div className="hu-mobile-powered-by">
                <p className="powered-by-text hu-a-center hu-color_contrast hu-s-12">
                  <a className="hu-border-color_contrast" target="_blank" href={referralFooterURL}>Create your own <b>Landbot</b></a>
                </p>
              </div>
            */}
          </div>
          <div className="hu-input-body">
            {input}
          </div>
        </div>
      );
    } else {
      return (
        <div className="hu-input-container"></div>
      );
    }
  }
}

export default InputBox;


// WEBPACK FOOTER //
// ./app/js/components/messenger/InputBox.js